export enum Views {
  SelectOption,
  Intro,
  RequestSent,
  AddIncomeSource,
  CombinedIncomeFlow,
  ReviewNewIncomeSource,
  RequestApplicantAddIncome,
  SuccessfullyAddedNewIncome
}
